import { render, staticRenderFns } from "./TransformModal.vue?vue&type=template&id=c2ddb610&scoped=true"
import script from "./TransformModal.vue?vue&type=script&lang=js"
export * from "./TransformModal.vue?vue&type=script&lang=js"
import style0 from "./TransformModal.vue?vue&type=style&index=0&id=c2ddb610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ddb610",
  null
  
)

export default component.exports